export default function () {
	if (window.Formie && window.Formie.$forms) {
		window.Formie.$forms.forEach(form => {
			form.reset();
			if (form.querySelector('[data-field-error-messages]'))
				form.querySelector('[data-field-error-messages]').remove();

			const inputs = form.querySelectorAll('.fui-error');
			inputs.forEach(input => {
				input.classList.remove('fui-error');
				input.removeAttribute('data-field-has-error');
			});
		});
	}
}
